// extracted by mini-css-extract-plugin
export default {"redirectButton":"ProductEditBasicSection_redirectButton__MHm8V","disconnectButton":"ProductEditBasicSection_disconnectButton__is3nn"};